import React from "react";
import Icon from "./Icon";
import type { IconProps } from "./IconProps";

const ArrowForwardIcon: React.FC<IconProps> = ({ className, title }) => {
  const svgPath = (
    <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
  );

  return (
    <Icon
      svgPath={svgPath}
      className={className}
      title={title}
      viewBox="0 0 24 24"
      fill="currentColor"
    />
  );
};

export default ArrowForwardIcon;
